import React, { Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import './scss/chat.scss'
import ProtectedRoutes from './ProtectedRoutes'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const IndigoBooking = React.lazy(() => import ('./views/bookIndigoFlight/book'))
const BookingCheckout = React.lazy(() => import ('./views/bookIndigoFlight/checkout'))

const App = () => {

  return (
    <>
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/" name="Login Page" element={<Login />} />
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route exact path="/external-indigo-booking/:id" name="External Indigo Booking" element={<IndigoBooking />} />
            <Route exact path="/external-booking-checkout" name="External Indigo Booking Checkout" element={<BookingCheckout />} />



            <Route path='/' element={<ProtectedRoutes />} >
              <Route path="*" name="Home" element={<DefaultLayout />} />
            </Route>
          </Routes>
        </Suspense>
      </HashRouter>
      {/* <InactiveUser  /> */}
    </>
  )

}

export default App
